export const ICONS = {
  domains: {
    travel: "🧭",
    work: "⚒️",
    combat: "⚔️",
    econ: "💰",
    social: "🕊️"
  },
  states: {
    idle: "⏳",
    active: "✅",
    resume: "▶️",
    paused: "⏸️",
    blocked: "⛔",
    warning: "⚠️",
    danger: "🛑"
  },
  sessions: {
    area: "🗺️",
    inventory: "🎒",
    equipment: "🛡️",
    skills: "📚",
    magic: "✨",
    workshop: "⚒️",
    bank: "🏦",
    exchange: "🏛️",
    social: "💬",
    stats: "📊",
    log: "🧾"
  },
  actions: {
    travel: "🧭",
    crafting: "⚒️",
    bank: "🏦",
    exchange: "🏛️",
    trade: "🏷️",
    switchCharacter: "🧙",
    logout: "🚪",
    talk: "💬",
    influence: "🧠",
    steal: "🧤",
    inspect: "🔍",
    combat: "⚔️",
    timer: "⏱️",
    trash: "🗑️",
    dice: "🎲",
    key: "🗝️",
    levelUp: "✨",
    spendAp: "⭐",
    settings: "⚙️",
    close: "✕",
    search: "🔎",
    quantity: "🔢",
    orders: "📜",
    inbox: "📥"
  },
  places: {
    station: "🏭",
    bank: "🏦",
    exchange: "🏛️",
    building: "🏠"
  },
  inspectKinds: {
    npc: "🕯️",
    player: "🧿"
  },
  ui: {
    globe: "🌐",
    lock: "🔒",
    plus: "➕",
    minus: "➖",
    unknown: "❔"
  },
  toasts: {
    info: "ℹ️",
    success: "✅",
    warning: "⚠️",
    error: "❌",
    item: "📦",
    xp: "⭐",
    combatGood: "🛡️",
    combatBad: "💢",
    default: "📢"
  },
  stats: {
    hp: "❤️",
    mana: "🔷"
  },
  itemsByType: {
    weapon: "⚔️",
    armor: "🛡️",
    tool: "🛠️",
    ammo: "🏹",
    jewelry: "💍",
    container: "🎒",
    consumable: "🧪",
    resource: "📦",
    gem: "💎",
    bait: "🪱",
    "spell-scroll": "📜",
    currency: "💰",
    unknown: "📦"
  },
  equipmentSlots: {
    head: "🪖",
    neck: "📿",
    chest: "🛡️",
    back: "🧥",
    main_hand: "⚔️",
    off_hand: "🛡️",
    hands: "🧤",
    ring: "💍",
    legs: "👖",
    feet: "🥾"
  },
  skills: {
    character: "👤",
    mining: "⛏️",
    woodcutting: "🪓",
    fishing: "🎣",
    fletching: "🏹",
    thieving: "🧤",
    magic: "✨",
    brewing: "🧪",
    herblore: "🌿",
    refining: "🔥",
    smithing: "🛠️",
    cooking: "🍳",
    clothing: "🧵",
    enameling: "🎨",
    inscribing: "📜",
    enchanting: "🔮"
  },
  combat: {
    melee: "⚔️",
    ranged: "🏹",
    magic: "✨",
    unarmed: "👊"
  }
} as const;
